export enum ParagraphProps {
    SMALL = 'small',
    MEDIUM = 'medium',
}
